export const defaultGoogleMapsApiKey = 'AIzaSyAR9crzIPVA2rrD94G10LhBSURY9-KVuzE';
//# sourceMappingURL=api-keys.js.map